import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, getResetByTag, rgba } from '../../../styles';
var dropDownMenuBackgroundDefaultStyles = function dropDownMenuBackgroundDefaultStyles() {
  return /*#__PURE__*/css("align-items:stretch;background-color:", colors.white, ";border-radius:0;display:flex;height:100%;justify-content:flex-end;position:absolute;right:0;top:0;width:100%;&:before{border:", rem(1), " solid ", colors.coolGray_800, ";border-radius:inherit;box-shadow:", rem(0, 0, 0, 0), " ", rgba(colors.lightBlue_500, 0.55), " inset ", rem(0, 0, 0, 0), " ", colors.coolGray_800, ";bottom:0;content:'';left:0;position:absolute;right:0;top:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropDownMenuBackgroundDefaultStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledDropdownMenuBackground = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1pjj6ck0"
} : {
  target: "e1pjj6ck0",
  label: "StyledDropdownMenuBackground"
})(resetStyles, dropDownMenuBackgroundDefaultStyles);
export default StyledDropdownMenuBackground;